import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Button, Modal, Form, Col, FormGroup, ControlLabel } from 'react-bootstrap'
import Dropdown from './dropdown'

@observer(['globals', 'contacts', 'invoices'])
export default class EmailInvoice extends Component {

    constructor(props) {
        super(props)
    }

    componentDidMount() {
        this.props.contacts.loadAllContactsByCompany(this.props.data.companyId);

        this.setState({
            quoteContactId: this.props.data.companyDefaultContactId
        })
    }


    closeEmailQuoteModal() {
        if (this.props.onClose) {
            this.props.onClose();
        }
    }

    onEmailQuoteContactIdChanged(e) {
        this.setState({
            quoteContactId: e.target.value
        })
    }

    emailQuote(row) {
        if (this.props.data.token && this.props.data.token.length > 0) {
            const params = {
                token: this.props.data.token,
                contactId: this.state.quoteContactId
            }

            if (confirm('Are you sure you want to send this invoice to the company?  This action cannot be undone!')) {
                this.props.invoices.emailInvoice(params, (data) => {
                    alert('Email sent!')
                    this.closeEmailQuoteModal();
                })
            } else {
                alert('Action cancelled.')
            }
        } else {
            alert('Invalid token')
        }
    }

    render() {

        return (
            <Modal show={this.props.open} onHide={this.closeEmailQuoteModal.bind(this)}>
                <Modal.Header closeButton>
                    <Modal.Title>Email Invoice</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form horizontal name="emailQuoteForm">
                        <FormGroup>
                            <Col componentClass={ControlLabel} sm={4}>Select Email:</Col>
                            <Col sm={8}><Dropdown data={this.props.contacts.contacts.map((contact) => ({ id: contact.id, name: contact.fullName + ' - ' + contact.email }))} defaultValue={this.props.data.companyDefaultContactId} onChange={this.onEmailQuoteContactIdChanged.bind(this)} /></Col>
                        </FormGroup>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button bsStyle="danger" onClick={() => { this.closeEmailQuoteModal() }}><i className="fa fa-ban" aria-hidden="true"></i> Cancel</Button>
                    <Button bsStyle="success" onClick={(e) => { this.emailQuote(e) }}><i className="fa fa-floppy-o" aria-hidden="true"></i> Send Invoice</Button>
                </Modal.Footer>
            </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/emailinvoice.js